module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [(_vm.styles === 1) ? _vm._l((_vm.songs), function(item) {
    return _c('li', {
      key: item.song_id,
      staticClass: "song-list",
      class: {
        active: _vm.songId === item.song_id
      },
      on: {
        "click": function($event) {
          _vm.fileLink(item, 1, _vm.songs)
        }
      }
    }, [(_vm.songId === item.song_id) ? _c('i', {
      staticClass: "iconfont active-icon"
    }, [_vm._v("")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": item.pic_small ? item.pic_small : item.pic_big,
        "alt": "",
        "width": "52",
        "height": "52"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "item-text .border-1px"
    }, [_c('h3', {
      staticClass: "item-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', [_vm._v("专辑：" + _vm._s(item.album_title))])])])
  }) : _vm._e(), _vm._v(" "), (_vm.styles === 2) ? _vm._l((_vm.songs), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "search-list",
      on: {
        "click": function($event) {
          _vm.fileLink(item, 2, item)
        }
      }
    }, [_c('div', {
      staticClass: "songname"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "album",
      domProps: {
        "innerHTML": _vm._s('-' + item.author)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "album",
      domProps: {
        "innerHTML": _vm._s(item.album_title)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "info",
      domProps: {
        "innerHTML": _vm._s(item.info)
      }
    })])
  }) : _vm._e(), _vm._v(" "), (_vm.styles === 3) ? _vm._l((_vm.songs), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "search-list",
      on: {
        "click": function($event) {
          _vm.fileLink(item, 1, _vm.songs)
        }
      }
    }, [_c('div', {
      staticClass: "songname"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "album",
      domProps: {
        "innerHTML": _vm._s('-' + item.author)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "album",
      domProps: {
        "innerHTML": _vm._s(item.album_title)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "info",
      domProps: {
        "innerHTML": _vm._s(item.info)
      }
    })])
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-20431369"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/songList/songList.vue
// module id = 194
// module chunks = 1